// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"f85ab254","513":"eec05a97","703":"facc0128"}[chunkId] + ".chunk.js";
};